import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "text-center",
  style: 'pointer-events: none'
}
const _hoisted_3 = {
  key: 1,
  style: 'pointer-events: none',
  class: "text-center"
}
const _hoisted_4 = {
  style: 'pointer-events: none',
  class: "text-center"
}
const _hoisted_5 = {
  style: 'pointer-events: none',
  class: "text-center"
}
const _hoisted_6 = {
  key: 2,
  width: "200px",
  class: "align-center"
}
const _hoisted_7 = {
  key: 3,
  style: 'pointer-events: none',
  class: "text-center"
}
const _hoisted_8 = {
  style: 'pointer-events: none',
  class: "text-center"
}
const _hoisted_9 = {
  style: 'pointer-events: none',
  class: "text-center"
}
const _hoisted_10 = {
  key: 4,
  style: 'pointer-events: none',
  class: "text-center"
}
const _hoisted_11 = {
  style: 'pointer-events: none',
  class: "text-center"
}
const _hoisted_12 = {
  style: 'pointer-events: none',
  class: "text-center"
}
const _hoisted_13 = {
  key: 5,
  class: "text-center",
  style: 'pointer-events: none'
}
const _hoisted_14 = {
  key: 6,
  class: "text-center",
  style: 'pointer-events: none'
}
const _hoisted_15 = {
  key: 7,
  class: "text-center",
  style: 'pointer-events: none'
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 8,
  class: "text-center",
  style: 'pointer-events: none'
}
const _hoisted_18 = {
  key: 9,
  class: "text-center",
  style: 'pointer-events: none'
}
const _hoisted_19 = {
  key: 10,
  class: "text-center",
  style: 'pointer-events: none'
}
const _hoisted_20 = {
  key: 11,
  style: 'pointer-events: none'
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ColumnCorrespondence = _resolveComponent("ColumnCorrespondence")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    flat: "",
    style: {"max-width":"1000px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step) = $event)),
        touchless: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_UploadDocuments, {
                showFirstPrevious: false,
                documentType: _ctx.documentType,
                inExtensions: ['csv', 'tsv', 'txt', 'xlsx', 'xls'],
                multiple: false,
                freeTag: false,
                gDrive: true,
                onFileInput: _ctx.onFileChanged,
                onFileDeleted: _ctx.onFileDeleted,
                onTestFileInput: _ctx.onTestFileChanged
              }, null, 8, ["documentType", "onFileInput", "onFileDeleted", "onTestFileInput"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 1 }, {
            default: _withCtx(() => [
              (_ctx.step > 0 && _ctx.existingFile)
                ? (_openBlock(), _createBlock(_component_ColumnCorrespondence, {
                    key: 0,
                    ref: "columnComponent",
                    result: _ctx.result,
                    extension: _ctx.extension,
                    actions: _ctx.actions,
                    ruleManager: _ctx.ruleManager,
                    formatColumns: _ctx.formatColumns,
                    requireDateVerification: true,
                    updateAccountingDates: true,
                    onColumnsChosen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChosenColumns($event))),
                    onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.step = 0))
                  }, null, 8, ["result", "extension", "actions", "ruleManager", "formatColumns"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 2 }, {
            default: _withCtx(() => [
              (_ctx.importedItems.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_ctx.missingVatTypes)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": "",
                          class: "justify-end align-center mx-5"
                        }, {
                          default: _withCtx(() => [
                            _cache[6] || (_cache[6] = _createTextVNode(" Type de tva général: ")),
                            _createVNode(_component_v_col, {
                              cols: "3",
                              class: "pl-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select_filled, {
                                  "hide-details": "",
                                  density: "compact",
                                  items: _ctx.vatTypes,
                                  modelValue: _ctx.generalVatType,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.generalVatType) = $event)),
                                  "item-title": "text",
                                  "item-value": "value"
                                }, null, 8, ["items", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "pl-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "btn",
                                  color: "primary",
                                  rounded: "",
                                  dark: "",
                                  size: "small",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setAllVatTypes(_ctx.generalVatType)))
                                }, {
                                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                                    _createTextVNode(" Appliquer ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_data_table, {
                      headers: _ctx.importedHeaders,
                      items: _ctx.importedItems,
                      class: "table",
                      density: "compact",
                      "fixed-header": "",
                      loading: _ctx.verifLoading
                    }, {
                      item: _withCtx(({ item, index }) => [
                        _createElementVNode("tr", {
                          style: _normalizeStyle('background-color:' + item.colorAlert)
                        }, [
                          (item.customer === 'NOTIN')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
                                _createVNode(_component_v_badge, {
                                  color: "primary",
                                  content: "New",
                                  location: "top end",
                                  floating: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.company), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_3, _toDisplayString(item.company), 1)),
                          _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.getSiretValue(item.siret)), 1),
                          _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.convertAmount(item.netAmount)) + " € ", 1),
                          (item.vatRate === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                                _createVNode(_component_v_select_filled, {
                                  "hide-details": "",
                                  density: "compact",
                                  modelValue: item.vatType,
                                  "onUpdate:modelValue": ($event: any) => ((item.vatType) = $event),
                                  items: _ctx.vatTypes,
                                  "item-title": "text",
                                  "item-value": "value",
                                  class: "py-1"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(item.vatRate1 ? "MultiTVA" : item.vatRate), 1)),
                          _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.convertDate(item.date)), 1),
                          _createElementVNode("td", _hoisted_9, _toDisplayString(item.dueDate ? _ctx.convertDate(item.dueDate) : ""), 1),
                          (_ctx.importedAccountingDates.length)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(item.accountingDate ? _ctx.convertDate(item.accountingDate) : ""), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", _hoisted_11, _toDisplayString(item.invoiceNumber), 1),
                          _createElementVNode("td", _hoisted_12, _toDisplayString(item.netAmount), 1),
                          (item.status === 'FULL_INVOICE_IN_DB')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_13, " La facture existe déjà "))
                            : (item.status === 'NO_AVLB_VAT')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_14, " La TVA à " + _toDisplayString(item.vatRate) + " n'existe pas ", 1))
                              : (item.status === 'NO_VAT_TYPE')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                                    (item.vatType)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          icon: "$fa-check",
                                          color: "green"
                                        }))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_16, "Le type de TVA n'existe pas"))
                                  ]))
                                : (item.status === 'PARTIAL_INVOICE_IN_DB')
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_17, " La facture existe déjà, mais certaines informations ne correspondent pas "))
                                  : (item.status === 'SIRET_WRONG')
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_18, " Le numero de SIRET n'est pas correct "))
                                    : (item.status === 'GOOD_INVOICE')
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                                          _createVNode(_component_v_icon, {
                                            icon: "$fa-check",
                                            color: "green"
                                          })
                                        ]))
                                      : (_openBlock(), _createElementBlock("td", _hoisted_20, [
                                          _createVNode(_component_v_progress_circular, {
                                            indeterminate: "",
                                            color: "primary"
                                          })
                                        ]))
                        ], 4)
                      ]),
                      _: 1
                    }, 8, ["headers", "items", "loading"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}